'use client'

import { useSports } from 'hooks'

import { LeagueSkeleton } from 'compositions/events/League/League'
import EmptyContent from 'compositions/events/EmptyContent/EmptyContent'
import Navbar, { NavbarSkeleton } from 'compositions/events/Navbar/Navbar'
import { useParams } from 'next/navigation'
import OvertimeUniqueEvents from '@/compositions/events/UniqueEvents/OvertimeUniqueEvents'
import OvertimeFilteredLeagues from '@/compositions/events/FilteredLeagues/OvertimeFilteredLeagues'

export default function OvertimeLeaguePage() {
  const params = useParams()

  const ogParams = useParams()

  //  const params =
  //    ogParams.sportSlug === 'american-football'
  //      ? 'football'
  //      : ogParams.sportSlug === 'football'
  //        ? 'soccer'
  //        : ogParams.sportSlug

  const { sports, loading } = useSports()

  if (loading) {
    return (
      <>
        <NavbarSkeleton />
        <LeagueSkeleton isPage />
      </>
    )
  }

  const sportSlug =
    params.sportSlug === 'football'
      ? 'soccer'
      : ogParams.sportSlug === 'american-football'
        ? 'football'
        : ogParams.sportSlug

  const sport = sports?.find(s => s.slug === sportSlug)
  const league = sport?.leagues?.find(l => l.slug === params?.leagueSlug)

  if (!sport || !league) {
    return <EmptyContent />
  }

  const { slug } = sport

  return (
    <Navbar>
      {sport.slug === 'unique' ? (
        <OvertimeUniqueEvents leagues={[league]} />
      ) : (
        <OvertimeFilteredLeagues sportSlug={slug} leagues={[league]} isPage />
      )}
    </Navbar>
  )
}
